/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProductCategoryQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ProductCategoryQueryOperator");
    }

    getFixupPrototypeFunction() { return ProductCategoryQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ProductCategoryQueryOperator>): ProductCategoryQueryOperator {
        let obj = Object.assign(new ProductCategoryQueryOperator(), model);
        ProductCategoryQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProductCategoryQueryOperator>): ProductCategoryQueryOperator {
        if (!model) return null;
        return ProductCategoryQueryOperator.newInstance(<ProductCategoryQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProductCategoryQueryOperator) {
        if (!obj) return;

        models.ProductCategoryQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProductCategoryQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProductCategoryQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Product categories to include
     */
    product_categories: Array<string>;

}
